import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

interface InternalAdminRouteProps {
    children: React.ReactNode;
}

export function InternalAdminRoute({ children }: InternalAdminRouteProps) {
    const { profile, isLoadingInitial, isAuthenticated } = useAuth();
    const location = useLocation();
    if (isLoadingInitial) {
        return (
            <div className="flex items-center justify-center h-screen w-full">
                <Loader2 className="w-10 h-10 text-neutral-400 animate-spin" />
            </div>
        );
    }

    if (isAuthenticated && profile?.is_internal_admin === true) {
        return <>{children}</>;
    }

    return <Navigate to="/signin" state={{ from: location }} replace />;
}